import { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';

import facebookLogo from '../../../../assets/images/facebook.png';
import playVideoIcon from '../../../../assets/images/play_video.png';
import SecurityMessage from '../SecurityMessage';
import './footer.scss';
import LoginContext from '../../../../store/login-context';
import OnlineServices from '../OnlineServices/OnlineServices';


declare var _siteSettings: any;
declare var _loginType: any;
declare var _loginTypePreRegCheck:any;
declare var _loginTypeWebAuthn:any;
declare var _loginTypeSMSOTP: any;
declare function Translate(key: string): string;

export const LinkTo = (e, link) => {
  if (e.keyCode === 13 || e.keyCode === 32) window.open(link);
};

const Footer = () => {

  const ctx = useContext(LoginContext);
   
  return (
    <div className='main-footer'>
      <div className='footer-desktop mx-md-3 px-md-3 px-lg-0 py-3'>
      <div className='securityAndLink'><SecurityMessage />{ !ctx.showRegFormOptions && <OnlineServices/> } </div><div className="down_line"/> 
        <Row className='px-2 d-flex flex-row regular'>
          <div className='d-flex justify-content-start'>
           {!(_loginType === _loginTypeSMSOTP && 
            !ctx.isBioIdClicked && !ctx.isScClicked  && !ctx.isPassKeyMarket )  && 
            <>           
            <div className='d-flex right flex-row align-items-center'>
              <div
                className='footer-link'
                role='link'
                onKeyDown={(e) => LinkTo(e, _siteSettings.faqLink)}
                onClick={() => window.open(_siteSettings.faqLink)}
                tabIndex={0}
              >
                {Translate('N_General_TEXT_FOOTER_FAQ')}
              </div>
            </div>
            <div className='d-flex right flex-row align-items-center'>
              <span className='footer-bullet bstrp-m-2'></span>
            </div>
            </>
            }
            <div className='d-flex right flex-row align-items-center'>
              <div
                className='footer-link'
                role='link'
                onKeyDown={(e) => LinkTo(e, _siteSettings.aboutLink)}
                onClick={() => window.open(_siteSettings.aboutLink)}
                tabIndex={0}
              >
                {Translate('N_General_about')}
              </div>
            </div>
            <div className='d-flex right flex-row align-items-center'>
              <span className='footer-bullet bstrp-m-2'></span>
            </div>            
            <div className='d-flex right flex-row align-items-center'>
              <div
                className='footer-link'
                title='call center'
                role='link'
                onKeyDown={(e) => LinkTo(e, _siteSettings.callCenterLink)}
                onClick={() => window.open(_siteSettings.callCenterLink)}
                tabIndex={0}
              >
                {Translate('N_General_TEXT_HELPDESK')}
              </div>
            </div>
            <div className='d-flex right flex-row align-items-center'>
              <span className='footer-bullet bstrp-m-2'></span>
            </div>
            <div className='d-flex right flex-row align-items-center'>
              <div
                className='footer-link'
                title='about'
                role='link'
                onKeyDown={(e) => LinkTo(e, _siteSettings.accessibilityLink)}
                onClick={() => window.open(_siteSettings.accessibilityLink)}
                tabIndex={0}
              >
                {Translate('N_General_Accessibility_declaration')}
              </div>
            </div>
            <div className='d-flex right flex-row align-items-center'>
              <span className='footer-bullet bstrp-m-2'></span>
            </div>
            <div className='d-flex right flex-row align-items-center'>
              <div
                className='footer-link'
                title='terms of use'
                role='link'
                onKeyDown={(e) => LinkTo(e, _siteSettings.termsOfUseLink)}
                onClick={() => window.open(_siteSettings.termsOfUseLink)}
                tabIndex={0}
              >
                {Translate('N_General_TEXT_FOOTER_TOS')}
              </div>
            </div>
          </div>

          <Col>
            <div className='d-flex justify-content-end align-items-center'>
              <div>
                <div
                  className='vid-container'
                  style={{
                    margin: '0',
                  }}
                  onKeyDown={(e) => LinkTo(e, _siteSettings.movieLink)}
                  onClick={() => window.open(_siteSettings.movieLink)}
                  tabIndex={0}
                  role='link'
                >
                  <img src={playVideoIcon} alt={Translate("N_General_Accessibility_Alt_Youtube")} className='' />
                </div>
              </div>
              <div
                className='footer-link'
                style={{
                  margin: '0',
                  marginRight: '10px',
                }}
                onKeyDown={(e) => LinkTo(e, _siteSettings.facebookLink)}
                onClick={() => window.open(_siteSettings.facebookLink)}
                tabIndex={0}
                role='link'
              >
                <img src={facebookLogo} alt={Translate("N_General_Accessibility_Alt_Facebook")} />
              </div>
            </div>
          </Col>
        </Row>

        <Row className='p-2 d-flex flex-row regular'>
          <div className='d-flex justify-content-start'>
            {Translate('N_General_all_right_reserved')}
          </div>
          <Col></Col>
        </Row>
      </div>

      {!ctx.showSideNote &&
        <div className='no_side_note'></div>
      } 
      <div className='footer-mobile'>        
        <div className='online_services_container'>
          <div>
            { !ctx.showRegFormOptions && <OnlineServices/> }
            <SecurityMessage />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
